export default "__VITE_ASSET__RM5Z2pPK__"